import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";

const Logo = (props) => {
  // const menuOpen = props.menuOpen;
  const [categoryName, setCategoryName] = useState("Slots");

  return (
    <>
      <Link
        hreflang={Translator.getSelectedLanguage().code}
        to="/"
        className="logo"
      >
        <img alt="" className="first-part" src={require("../assets/play365/images/logos/logo.webp")} />
        {/* {!props.isMobileDevice && <span>PC Play365 </span>} */}
        {!props.isMobileDevice && (

          <img
            src={require("assets/play365/images/logos/logo-text.webp")}
            className="second-part"
          />

        )}
      </Link>
    </>
  );
};

export default Logo;
